import { useContext, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { listConfigs } from "../services/apiService";
import SecondaryButton from "./SecondaryButton";
import * as buttonStatus from "../constants/buttonStatus";
import { FormContext } from "../context/FormContext";
import useUserInfoAndLogging from "../utils/useUserInfoAndLogging";
import useBearerToken from "../utils/useBearerToken";

const ConfigNavbar = ({ setShowConfigWindow }) => {
  const { instance, accounts } = useMsal();
  const getToken = useBearerToken();

  const { REACT_APP_B2B, REACT_APP_B2C } = process.env;
  const b2x = REACT_APP_B2B === "true" || REACT_APP_B2C === "true";

  const [exporting, setExporting] = useState(buttonStatus.READY);

  const { formState } = useContext(FormContext);
  const { reference } = formState;
  const { logException } = useUserInfoAndLogging();

  const loadData = async () => {
    setExporting(buttonStatus.RUNNING);
    const token = await getToken(instance, accounts, b2x);
    listConfigs(token).then((p) => {
      if (p instanceof Error) logException(p);
      if (!p) {
        setExporting(buttonStatus.FAILED);
        setTimeout(() => setExporting(buttonStatus.READY), 3000);
        return;
      }
      setShowConfigWindow(p);
      setExporting(buttonStatus.READY);
    });
  };

  const text =
    reference.version?.number > 0
      ? `${reference.version?.client} v${reference.version?.number}`
      : "Configuration";

  return (
    <SecondaryButton
      id="viewConfigButton"
      loadingText="Opening"
      failedText="Failed"
      disabled={false}
      status={exporting}
      onClick={loadData}
      text={text}
      title="View Config"
    />
  );
};

export default ConfigNavbar;
